import { useEffect, useState } from "react";
import MultiChecboxSelector from "../controls/MultiCheckboxSelector";
import NumericSliderSelector from "../controls/NumericSliderSelector";
import { products } from "../utils/calcs";

export default function CalculatorComponent({
  scaleVal,
  screenRef,
  clearValuesTrigger,
  setClearValuesTrigger,
  setParSavedPerMonth,
  setParClicksPerMonth,
  setParSelectedSolutions,
  setLoanCount
}) {
  const [savedPerMonth, setSavedPerMonth] = useState(0);
  const [savedPerYear, setSavedPerYear] = useState(0);
  const [clicksPerMonth, setClicksPerMonth] = useState(0);
  const [hoursPerMonth, setHoursPerMonth] = useState(0);
  const [selectedSolutions, setSelectedSolutions] = useState([]);
  const [resetVals, setResetVals] = useState(false);

  const [expandedCtls, setExpandedCtls] = useState([
    {
      index: 0,
      expanded: false,
      val: null,
    },
    {
      index: 1,
      expanded: false,
      val: null,
    },
    {
      index: 2,
      expanded: false,
      val: null,
    },
  ]);

  useEffect(() => {
    if (clearValuesTrigger) {
      clearValues();
      if (setClearValuesTrigger) setClearValuesTrigger(false);
    }
  }, [clearValuesTrigger, setClearValuesTrigger]);

  useEffect(() => {
    calcValues();
  }, [expandedCtls]);

  useEffect(() => {
    if (resetVals) setResetVals(false);
  }, [resetVals]);

  useEffect(() => {
    setParValues();
  }, [clicksPerMonth, savedPerMonth, selectedSolutions]);

  function setParValues() {
    if (setParClicksPerMonth) setParClicksPerMonth(clicksPerMonth);
    if (setParSavedPerMonth) setParSavedPerMonth(savedPerMonth);
    if (setParSelectedSolutions) setParSelectedSolutions(selectedSolutions);
    if (setLoanCount) setLoanCount(expandedCtls[0]?.val ?? 0)
  }

  function clearValues() {
    setResetVals(true);
    setExpandedCtls([
      {
        index: 0,
        expanded: false,
        val: 100,
      },
      {
        index: 1,
        expanded: false,
        val: null,
      },
      {
        index: 2,
        expanded: false,
        val: 80,
      },
    ]);

    setSavedPerMonth(0);
    setSavedPerYear(0);
    setClicksPerMonth(0);
    setHoursPerMonth(0);
  }

  function getExpanded(index) {
    return expandedCtls[index].expanded;
  }

  function setExpanded(index, val) {
    var tmp = [...expandedCtls];
    tmp[index].expanded = val;
    if (val === true) {
      expandedCtls.forEach((x) => {
        if (x.index !== index && x.expanded === true) {
          x.expanded = false;
        }
      });
    }
    setExpandedCtls([...tmp]);
  }

  function setControlValue(index, val) {
    var tmp = [...expandedCtls];
    if (tmp[index].val !== val) {
      tmp[index].val = val;
      setExpandedCtls([...tmp]);
    }

    if (setLoanCount){
      setLoanCount(expandedCtls[0].val ?? 0);
    }
  }

  function calcValues() {
    setSavedPerMonth(calculateSavedPerMonth());
    setSavedPerYear(calculateSavedPerYear());
    setClicksPerMonth(calculateClicksPerMonth());
    setHoursPerMonth(calculateHoursPerMonth());
  }

  function calculateSavedPerMonth() {
    var total = 0;

    var closedLoans = expandedCtls[0].val ?? 0;
    var avgsalary = expandedCtls[2].val ?? 0;

    for (let i = 0; i < selectedSolutions.length; i++) {
      var prod = products.find((x) => x.Id === selectedSolutions[i].key);
      if (prod) {
        if (prod?.Calcs.length > 1) {
          var mcalc = prod?.Calcs[1];

          if (mcalc != null) {
            var result = mcalc(prod.Id, closedLoans, avgsalary);
            total += result;
          }
        }
      }
    }
    return total;
  }

  function calculateSavedPerYear() {
    var total = 0;

    var closedLoans = expandedCtls[0].val ?? 0;
    var avgsalary = expandedCtls[2].val ?? 0;

    for (let i = 0; i < selectedSolutions.length; i++) {
      // selectedSolutions[i];
      var prod = products.find((x) => x.Id === selectedSolutions[i].key);
      if (prod) {
        if (prod?.Calcs.length > 1) {
          var mcalc = prod?.Calcs[1];

          if (mcalc != null) {
            var result = mcalc(prod.Id, closedLoans, avgsalary);
            total += result;
          }
        }
      }
    }
    return total * 12;
  }

  function calculateClicksPerMonth() {
    var total = 0;

    var closedLoans = expandedCtls[0].val ?? 0;
    var avgsalary = expandedCtls[2].val ?? 0;

    for (let i = 0; i < selectedSolutions.length; i++) {
      // selectedSolutions[i];
      var prod = products.find((x) => x.Id === selectedSolutions[i].key);
      if (prod) {
        if (prod?.Calcs.length > 0) {
          var ccalc = prod?.Calcs[0];

          if (ccalc != null) {
            var result = ccalc(prod.Id, closedLoans, avgsalary);
            total += result;
          }
        }
      }
    }
    return total;
  }

  function calculateHoursPerMonth() {
    var total = 0;

    var closedLoans = expandedCtls[0].val ?? 0;
    var avgsalary = expandedCtls[2].val ?? 0;

    for (let i = 0; i < selectedSolutions.length; i++) {
      var prod = products.find((x) => x.Id === selectedSolutions[i].key);
      if (prod) {
        if (prod?.Calcs.length > 2) {
          var hcalc = prod?.Calcs[2];

          if (hcalc != null) {
            var result = hcalc(prod.Id, closedLoans, avgsalary);
            total += result;
          }
        }
      }
    }
    return total;
  }

  function getTools() {
    var ret = [];
    for (let i = 0; i < selectedSolutions.length; i++) {
      var prod = products.find((x) => x.Id === selectedSolutions[i].key);

      if (prod) {
        ret.push(prod.Name);
      }
    }
    return ret;
  }

  function getMoneyPerMonth() {
    return formatter.format(savedPerMonth);
  }
  function getMoneyPerYear() {
    return formatter.format(savedPerYear);
  }
  function gtClicksPerMonth() {
    var tmp = clicksPerMonth;
    var retString = getFormattedNumber(tmp).toString();
    if (tmp > 0) {
      if (tmp < 1000) {
        retString = retString + " Clicks";
      } else {
        tmp = tmp / 1000;
        retString = getFormattedNumber(tmp).toString() + "K Clicks";
      }
    } else {
      return "0";
    }

    return retString;

    // return getFormattedNumber(tmp).toString() + 'K Clicks';
  }
  function getHoursPerMonth() {
    if (hoursPerMonth > 0) {
      return getFormattedNumber(hoursPerMonth).toString() + " Hours";
    }
    return "0";
  }

  const getFormattedNumber = (input) => {
    input = Math.round(input);
    return input.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  return (
    <>
      <div className={["control-row", "mw-row"].join(" ")}>
        <NumericSliderSelector
          labelText={"Average # of Closed Loans Per Month"}
          defaultVal={"Average # of"}
          expanded={getExpanded(0)}
          setExpanded={setExpanded}
          index={0}
          minVal={0}
          maxVal={5000}
          step={10}
          setControlValue={setControlValue}
          resetVal={resetVals}
          defaultStartVal={100}
        />
      </div>

      <div className={["control-row", "mw-row"].join(" ")}>
        <MultiChecboxSelector
          labelText={"KM Automations/Tools/Solutions"}
          defaultVal={"Choose Which"}
          cbOptions={products}
          selectedOptions={selectedSolutions}
          setSelectedOptions={setSelectedSolutions}
          expanded={getExpanded(1)}
          setExpanded={setExpanded}
          index={1}
          setControlValue={setControlValue}
          resetVal={resetVals}
        />
      </div>

      <div className={["control-row", "mw-row"].join(" ")}>
        <NumericSliderSelector
          labelText={"Average Production Staff Salary"}
          defaultVal={""}
          expanded={getExpanded(2)}
          setExpanded={setExpanded}
          index={2}
          minVal={0}
          maxVal={250}
          step={5}
          abbrev={"K"}
          isMoney={true}
          setControlValue={setControlValue}
          resetVal={resetVals}
          defaultStartVal={80}
        />
      </div>

      <div className={["summary-section-grid"].join(" ")} ref={screenRef}>
        <div className={["summ-block", "tl"].join(" ")}>
          <div className={["summ-hdr-mny"].join(" ")}>{getMoneyPerMonth()}</div>

          <div className={["summ-hdr"].join(" ")}>Dollars Saved Per Month</div>
        </div>

        <div className={["summ-block", "tr"].join(" ")}>
          <div className={["summ-hdr-cnt"]}>{gtClicksPerMonth()}</div>
          <div className={["summ-hdr"]}>Clicks Saved Per Month</div>
        </div>

        <div className={["summ-block", "bl"].join(" ")}>
          <div className={["summ-hdr-mny"].join(" ")}>{getMoneyPerYear()}</div>
          <div className={["summ-hdr"].join(" ")}>Dollars Saved Per Year</div>
        </div>

        <div className={["summ-block", "br"].join(" ")}>
          <div className={["summ-hdr-cnt"]}>{getHoursPerMonth()}</div>
          <div className={["summ-hdr"]}>Hours Saved Per Month</div>
        </div>
      </div>
    </>
  );
}
